export const SET_PRODUITS = 'SET_PRODUITS';
export const SET_TOTAL_PRODUIT = 'SET_TOTAL_PRODUIT';
export const SET_DATE_PLANNING = 'SET_DATE_PLANNING';
export const SET_BRIEF = 'SET_BRIEF';
export const CLEAR_BRIEF = 'CLEAR_BRIEF';
export const ADD_LIGNE_IN_PANIER = 'ADD_LIGNE_IN_PANIER';
export const SET_LOGO = 'SET_LOGO';
export const DELETE_LIGNE_IN_PANIER = 'DELETE_LIGNE_IN_PANIER';
export const SET_REGROUPEMENT_PERSONNALISE = 'SET_REGROUPEMENT_PERSONNALISE';
export const CLEAR_PANIER = 'CLEAR_PANIER';
export const SET_AFFICHER_ANNONCEUR = 'SET_AFFICHER_ANNONCEUR';
export const SET_AFFICHER_FACES_AFFECTEES = 'SET_AFFICHER_FACES_AFFECTEES';
export const SET_PANIER = 'SET_PANIER';
export const SET_TYPE_DCF = 'SET_TYPE_DCF';
export const SET_USE_ECRAN_AJOUT = 'SET_USE_ECRAN_AJOUT';
export const SET_BOUTON_OPTION = 'SET_BOUTON_OPTION';
export const SET_BOUTON_BLOQUER = 'SET_BOUTON_BLOQUER';
export const CLEAR_BOUTONS = 'CLEAR_BOUTONS';
export const SET_PRODUITS_LOCATION = 'SET_PRODUITS_LOCATION';
export const SET_BOUTON_SELECTION = 'SET_BOUTON_SELECTION';
export const SET_PRODUITS_RESEAUX = 'SET_PRODUITS_RESEAUX';
export const SET_PRODUIT_RESEAU = 'SET_PRODUIT_RESEAU';
